import img from "../../img/US_SHADE.webp";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";


const Feature = ({ icon, title, text }) => (
  <div className="us-feature">
    <div data-aos="fade-up" className="us-feature-icon">{icon}</div>
    <h4 data-aos="fade-up">{title}</h4>
    <p data-aos="fade-up">{text}</p>
  </div>
);

const SectionTitle = ({ small, big }) => (
  <div className="us-section-title">
    <span data-aos="fade-up">{small}</span>
    <h2 data-aos="fade-up">{big}</h2>
  </div>
);

export default function UsShadePage() {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });

    
  }, []);

  return (
    
    
    <div className="us-page">

      {/* HERO */}
      <section className="us-hero">
        <div className="us-hero-content">
          <div data-aos="fade-right" className="us-badge">
            <h3>
              <span className="subtitle-us">US</span> <b>SHADE</b>
            </h3>
          </div>

          <h1 data-aos="fade-up">
            Voiles d’ombrage et pergolas textiles
          </h1>

          <p data-aos="fade-up">
            Solutions d’ombrage efficaces pour terrasses, patios,
            piscines et espaces publics, bloquant plus de 90 % des
            rayons UV tout en laissant circuler l’air.
          </p>

          <div data-aos="zoom-in" className="us-hero-buttons">
            <a className="btn-primarya" href="/devis">
              Demander un devis
            </a>
            <a
              href="/docs/fiche-technique-us-shade.pdf"
              download
              className="btn-outline"
            >
              Télécharger la fiche technique
            </a>
          </div>
        </div>

        <div data-aos="fade-up" className="us-hero-image">
          <img src={img} alt="US Shade voile d’ombrage" />
        </div>
      </section>

      {/* DESCRIPTION */}
      <section className="us-section">
        <SectionTitle
          small="Présentation"
          big="Qu’est-ce que la solution US SHADE ?"
        />

        <div className="us-two-cols">
          <p data-aos="fade-up">
            Les voiles d’ombrage et pergolas textiles offrent une
            protection solaire efficace pour les espaces extérieurs
            tout en conservant une esthétique moderne.
          </p>

          <p data-aos="fade-up">
            Elles bloquent plus de 90 % des rayons UV nocifs et
            permettent une ventilation naturelle, idéales pour
            terrasses, piscines et espaces publics.
          </p>
        </div>
      </section>

      {/* AVANTAGES */}
      <section className="us-section us-gray">
        <SectionTitle small="Atouts" big="Avantages clés" />

        <div className="us-grid">
          <Feature icon="☀️" title="Protection UV" text="Blocage de plus de 90 % des rayons UV." />
          <Feature icon="🌧️" title="Protection intempéries" text="Protection contre soleil et pluie légère." />
          <Feature icon="🎨" title="Design moderne" text="Aspect esthétique et architectural." />
          <Feature icon="⚡" title="Installation rapide" text="Mise en place simple et rapide." />
          <Feature icon="🌬️" title="Ventilation naturelle" text="Évacuation de la chaleur sous la voile." />
          <Feature icon="🏡" title="Usage extérieur" text="Idéal pour terrasses, piscines et jardins." />
        </div>
      </section>
      {/* TECHNIQUE */}
<section className="us-section">
  <SectionTitle
    small="Technique"
    big="Caractéristiques techniques"
  />

  <ul data-aos="fade-up" className="us-list">
    <li>Voiles d’ombrage textiles haute résistance</li>
    <li>Blocage de plus de 90 % des rayons UV</li>
    <li>Matériaux résistants aux intempéries</li>
    <li>Circulation naturelle de l’air et évacuation de la chaleur</li>
    <li>Large choix de formes, couleurs et dimensions</li>
    <li>Solutions sur mesure pour extérieur</li>
    <li>Installation rapide et légère</li>
  </ul>
</section>

{/* APPLICATIONS */}
<section className="us-section us-gray">
  <SectionTitle
    small="Applications"
    big="Domaines d’utilisation"
  />

  <div className="us-tags" data-aos="fade-up">
    {[
      "Terrasses",
      "Patios",
      "Piscines",
      "Restaurants",
      "Jardins",
      "Parkings",
      "Aires de jeux",
      "Espaces publics",
      "Hôtels",
      "Zones de détente",
    ].map((item) => (
      <span key={item}>{item}</span>
    ))}
  </div>
</section>



      {/* CTA */}
      <section className="us-cta">
        <h2>Créer un espace ombragé et design ?</h2>
        <p>Nos équipes vous accompagnent dans votre projet.</p><br/>
        <a href="/contact" className="btn-primarya">
          Contactez-nous
        </a>
      </section>

    </div>
    
  );
}
